<template>
  <div class="call-handler">
    <div class="call-handler-contents">
      <div class="call-handle-buttons-container">
        <b-row class="call-history-row">
          <b-col cols="9">
            <p class="call-history-values call-history-values-name">
              <b> ( {{ hold_status ? "On Hold" : "Connected" }} ) </b>
              {{ caller_name }}
            </p>
          </b-col>
          <b-col cols="3" class="text-left">
            <b-tooltip
              target="tooltip-target-dp"
              triggers="hover"
              :noninteractive="true"
              placement="bottom"
              >Hold/Resume</b-tooltip>
            <font-awesome-icon
              v-if="!hold_status && !hold_status && !third_party_hold_status"
              class="contact-side-icon initialhold"
              @click="OnholdToggleInitialCall()"
              icon="pause"
              size="sm"
              style="margin-right: 5px; color: #636e72;"
            />
            <font-awesome-icon
              v-if="hold_status && third_party_hold_status"
              class="contact-side-icon initialhold"
              @click="OnholdToggleInitialCall()"
              icon="play"
              size="sm"
              style="margin-right: 5px; color: #636e72;"
            />
            <font-awesome-icon
              class="contact-side-icon initialhold"
              @click="OnEndInitialCall()"
              icon="phone-slash"
              size="sm"
              style="margin-right: 5px; color:#636e72"
            />
          </b-col>
        </b-row>

        <b-row class="call-history-row">
          <b-col cols="9">
            <p class="call-history-values call-history-values-name">
              <b>
                ( {{ third_party_hold_status ? "On Hold" : "Connected" }} )
              </b>
              {{ third_party_caller_name }}
            </p>
          </b-col>
          <b-col cols="3" class="text-left">
            <!-- <b-tooltip
              target="tooltip-target-dp"
              triggers="hover"
              :noninteractive="true"
              placement="bottom"
              >Hold/Resume</b-tooltip
            > -->
            <font-awesome-icon
              v-if="
                !third_party_hold_status &&
                  !hold_status &&
                  !third_party_hold_status
              "
              class="contact-side-icon"
              @click="OnholdToggleThirdPartyCall()"
              icon="pause"
              size="sm"
              style="margin-right: 5px; color:#636e72"
            />

            <font-awesome-icon
              v-if="
                third_party_hold_status &&
                  hold_status &&
                  third_party_hold_status
              "
              class="contact-side-icon initialhold"
              @click="OnholdToggleThirdPartyCall()"
              icon="play"
              size="sm"
              style="margin-right: 5px; color:#636e72"
            />
            <b-tooltip
              target="tooltip-target-dp"
              triggers="hover"
              :noninteractive="true"
              placement="bottom"
              >End Call</b-tooltip
            >
            <font-awesome-icon
              class="contact-side-icon initialhold"
              @click="OnEndThirdPartyCall()"
              icon="phone-slash"
              size="sm"
              style="color:#636e72"
            />
          </b-col>
        </b-row>

        <div class="call-handle-buttons-container">
          <b-button
            v-b-tooltip.hover.bottom
            title="Hold All"
            size="sm"
            v-if="
              (!hold_status && !third_party_hold_status) ||
                (hold_status && !third_party_hold_status) ||
                (!hold_status && third_party_hold_status)
            "
            @click="OnHoldAll()"
            pill
            class="call-control-buttons"
            variant="secondary"
          >
            <font-awesome-icon icon="pause" size="sm" />
          </b-button>

          <b-button
            v-b-tooltip.hover.bottom
            title="Resume All"
            size="sm"
            v-if="hold_status && third_party_hold_status"
            @click="OnResumeAll()"
            pill
            class="call-control-buttons"
            variant="secondary"
          >
            <font-awesome-icon icon="play" size="sm" />
          </b-button>

          <b-button
            size="sm"
            v-b-tooltip.hover.bottom
            :title="mute_status? 'Unmute' : 'Mute'"
            @click="OnMuteToggle()"
            pill
            class="call-control-buttons"
            :variant="mute_status ? 'primary' : 'secondary'"
          >
            <font-awesome-icon
              :icon="mute_status ? 'microphone-alt-slash' : 'microphone-alt'"
              size="sm"
            />
          </b-button>
          <!-- Why this button -->
          <b-button
            v-b-tooltip.hover.bottom
            title="Join"
            size="sm"
            v-if="
              (hold_status && !third_party_hold_status) ||
                (!hold_status && third_party_hold_status)
            "
            @click="OnJoinCall()"
            pill
            class="call-control-buttons"
            variant="secondary"
          >
            <font-awesome-icon icon="retweet" />
          </b-button>
          <!-- Why this button -->

          <b-button
            v-b-tooltip.hover.bottom
            title="Swap"
            size="sm"
            v-if="
              (hold_status && !third_party_hold_status) ||
                (!hold_status && third_party_hold_status)
            "
            @click="OnSwapCall()"
            pill
            class="call-control-buttons"
            variant="secondary"
          >
            <font-awesome-icon icon="exchange-alt" size="sm" />
          </b-button>

          <b-button
            size="sm"
            v-b-tooltip.hover.bottom
            title="Number Pad"
            @click="OnNumberPadToggle()"
            pill
            class="call-control-buttons"
            :variant="ivrDialPad ? 'primary' :'secondary'"
          >
            <font-awesome-icon
             icon="th"
              size="sm"
            />
          </b-button>

          <b-button
            v-b-tooltip.hover.bottom
            title="Notes"
            size="sm"
            @click="addNotes()"
            pill
            class="call-control-buttons"
            variant="secondary"
          >
            <font-awesome-icon icon="sticky-note" size="sm" />
          </b-button>
          <!-- <b-tooltip
            target="tooltip-target-end"
            triggers="hover"
            :noninteractive="true"
            placement="bottom"
            >End Call</b-tooltip
          > -->
          <b-button
            
            v-b-tooltip.hover.bottom
            title="Leave Call"
            @click="OnLeaveCall()"
            class="call-control-buttons leavecallconference"
            size="sm"
            variant="danger"
            pill
            
          >
            <font-awesome-icon icon="phone-slash" size="sm" />
          </b-button>
          <div v-if="ivrDialPad == true" class="call-handler-dialpad-container">

            <b-form-input v-model="number" type="tel" placeholder="Enter IVR"> 
              <font-awesome-icon icon="backspace" @click="removeDigits()" size="md" /></b-form-input>
            <div class="dialpad-button-container">
      <div v-if="ivrNumber.length>0" class="backspace">
             
          </div>
     
      <div class="button-row">
      <b-button
        variant="outline-secondary"
        class="dialpad-button"
        @click="keyDial('1')"
        @mousedown="dialTone(697.0, 1209.0)"
        @mouseup="stop()"
      >
        <div class="dialpad-number">1</div>
        <div class="dialpad-filler"></div>
      </b-button>
      <b-button
        variant="outline-secondary"
        class="dialpad-button"
        @click="keyDial('2')"
        @mousedown="dialTone(697.0, 1336.0)"
        @mouseup="stop()"
      >
        <div class="dialpad-number">2</div>
        <div class="dialpad-letters">ABC</div>
      </b-button>
      <b-button
        variant="outline-secondary"
        class="dialpad-button"
        @click="keyDial('3')"
        @mousedown="dialTone(697.0, 1477.0)"
        @mouseup="stop()"
      >
        <div class="dialpad-number">3</div>
        <div class="dialpad-letters">DEF</div>
      </b-button>
    </div>
    <div class="button-row">
      <b-button
        variant="outline-secondary"
        class="dialpad-button"
        @click="keyDial('4')"
        @mousedown="dialTone(770.0, 1209.0)"
        @mouseup="stop()"
      >
        <div class="dialpad-number">4</div>
        <div class="dialpad-letters">GHI</div>
      </b-button>
      <b-button
        variant="outline-secondary"
        class="dialpad-button"
        @click="keyDial('5')"
        @mousedown="dialTone(770.0, 1336.0)"
        @mouseup="stop()"
      >
        <div class="dialpad-number">5</div>
        <div class="dialpad-letters">JKL</div>
      </b-button>
      <b-button
        variant="outline-secondary"
        class="dialpad-button"
        @click="keyDial('6')"
        @mousedown="dialTone(770.0, 1477.0)"
        @mouseup="stop()"
      >
        <div class="dialpad-number">6</div>
        <div class="dialpad-letters">MNO</div>
      </b-button>
    </div>
    <div class="button-row">
      <b-button
        variant="outline-secondary"
        class="dialpad-button"
        @click="keyDial('7')"
        @mousedown="dialTone(852.0, 1209.0)"
        @mouseup="stop()"
      >
        <div class="dialpad-number">7</div>
        <div class="dialpad-letters">PQRS</div>
      </b-button>
      <b-button
        variant="outline-secondary"
        class="dialpad-button"
        @click="keyDial('8')"
        @mousedown="dialTone(852.0, 1336.0)"
        @mouseup="stop()"
      >
        <div class="dialpad-number">8</div>
        <div class="dialpad-letters">TUV</div>
      </b-button>
      <b-button
        variant="outline-secondary"
        class="dialpad-button"
        @click="keyDial('9')"
        @mousedown="dialTone(852.0, 1477.0)"
        @mouseup="stop()"
      >
        <div class="dialpad-number">9</div>
        <div class="dialpad-letters">WXYZ</div>
      </b-button>
    </div>
    <div class="button-row">
      <b-button
        variant="outline-secondary"
        class="dialpad-button"
        @click="keyDial('*')"
        @mousedown="dialTone(941.0, 1209.0)"
        @mouseup="stop()"
      >
        <div class="dialpad-number">*</div>
      </b-button>
      <b-button
        variant="outline-secondary"
        class="dialpad-button"
        @click="keyDial('0')"
        @mousedown="dialTone(941.0, 1336.0)"
        @mouseup="stop()"
      >
        <div class="dialpad-number">0</div>
        <div class="dialpad-letters">+</div>
      </b-button>
      <b-button
        variant="outline-secondary"
        class="dialpad-button"
        @click="keyDial('#')"
        @mousedown="dialTone(941.0, 1477.0)"
        @mouseup="stop()"
      >
        <div class="dialpad-number">#</div>
      </b-button>

      
    </div>

 


    </div>

          </div> 
        </div>
      </div>
    </div>
   
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import "amazon-connect-streams";
import "amazon-connect-chatjs";

import {
  onholdToggleInitialCall,
  onholdToggleThirdPartyCall,
  onMuteToggle,
  onSwapCall,
  onJoinCall,
  onHoldAll,
  onResumeAll,
  onLeaveCall,
  onEndIntialCall,
  onEndThirdPartyCall,
} from "../../../lib/CallActions.js";

import NumberPad from '../../NumberPad'

export default {
  name: "IncomingCall",
  mounted(){
    this.contextClass =
      window.AudioContext ||
      window.webkitAudioContext ||
      window.mozAudioContext ||
      window.oAudioContext ||
      window.msAudioContext
    if (this.contextClass) {
      this.context = new this.contextClass()
    }





  },
  data() {
    return {
      number:"",
      numberPad:false,
      ivrDialPad:false,
      dialPadToggleStatus: true,
      contextClass: null,
      context: null,
      oscillator1: null,
      oscillator2: null,
      gainNode: null,
      dialedNumber: '',
    };
  },
  methods: {
    OnholdToggleInitialCall() {
      onholdToggleInitialCall();
    },
    OnholdToggleThirdPartyCall() {
      onholdToggleThirdPartyCall();
    },
    OnEndInitialCall() {
      onEndIntialCall();
    },
    OnEndThirdPartyCall() {
      onEndThirdPartyCall();
    },
    OnMuteToggle() {
      onMuteToggle(this.mute_status);
    },
    OnSwapCall() {
      onSwapCall();
    },
    OnJoinCall() {
      onJoinCall();
    },
    OnHoldAll() {
      onHoldAll();
    },
    OnResumeAll() {
      onResumeAll();
    },
    OnLeaveCall() {
      if(this.number.length > 0 ){
        this.number = "";
      }
      onLeaveCall();
    },
    addNotes() {
      this.$store.dispatch("call/updateNotesEditor", true);
      this.ivrDialPad = false;
    },
    OnNumberPadToggle(){
      if(this.ivrDialPad == false){
        this.ivrDialPad = true
      }else{
        this.ivrDialPad = false

      }
      this.$store.dispatch("call/updateNotesEditor", false);

      // this.$store.dispatch('actions/callSubNavigation', 'numberpad')

      // if(this.isConferenceNumberPadUpdated){
      //   this.$store.dispatch("call/updateNumberPadConferenceEditor",false)
      // }else{
      //   this.$store.dispatch("call/updateNumberPadConferenceEditor",true)

      // }

      

    },
    keyDial(number){
      if ((number) => 0 && number <= 9) {
        this.number = this.number + number
        this.$store.dispatch('call/setIvrNumber', this.ivrNumber + ivrNumber)
      }
    },
    dialTone(freq1, freq2) {
      var vm = this
      vm.oscillator1 = vm.context.createOscillator()
      vm.oscillator1.type = 0
      vm.oscillator1.frequency.value = freq1
      vm.gainNode = vm.context.createGain
        ? vm.context.createGain()
        : vm.context.createGainNode()
      vm.oscillator1.connect(vm.gainNode, 0, 0)
      vm.gainNode.connect(vm.context.destination)
      vm.gainNode.gain.value = 0.1
      vm.oscillator1.start ? vm.oscillator1.start(0) : vm.oscillator1.noteOn(0)
      vm.oscillator2 = vm.context.createOscillator()
      vm.oscillator2.type = 0
      vm.oscillator2.frequency.value = freq2
      vm.gainNode = vm.context.createGain
        ? vm.context.createGain()
        : vm.context.createGainNode()
      vm.oscillator2.connect(vm.gainNode)
      vm.gainNode.connect(vm.context.destination)
      vm.gainNode.gain.value = 0.1
      vm.oscillator2.start ? vm.oscillator2.start(0) : vm.oscillator2.noteOn(0)
      console.log('the dial tone was clicked')
    },
    stop() {
      var vm = this
      vm.oscillator1.disconnect()
      vm.oscillator2.disconnect()
    }
  
    
  },
  computed: {
    ...mapGetters([
      "call_state",
      "caller_name",
      "queue_name",
      "caller_number",
      "mute_status",
      "hold_status",
      "third_party_hold_status",
      "third_party_caller_name",
      "isConferenceNumberPadUpdated",
      "ivrNumber"
    ]),
  },
};
</script>

<style scoped>
.contact-side-icon {
  color: #ccc;
  cursor: pointer;
}

.initialhold:hover {
  color: #2c5cc5 !important;

}

.call-history-values {
  margin-bottom: 0px !important;
  text-align: left !important;
}

.call-history-values-name {
  font-size: 13px !important;
  cursor: pointer;
}

.call-history-values-name:hover {
  color: #2c5cc5;
}

.call-history-row {
  padding: 5px 0;
}

.call-handle-buttons-container {
  margin-top: 4px;
  /* margin-left: 0.6rem; */
  /* margin-bottom: 0.5rem; */
}

.call-handle-buttons {
  width: 110px;
  margin: 0 5px;
}

/* .leavecallconference {
  margin-top: 5px !important; 
} */

.call-handler {
  display: table;
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
.call-handler-contents {
  display: table-cell;
  margin: 0;
}

.call-control-buttons {
  margin: 0 5px;
  /* margin: 0 0.85rem 0 0; */
}

.call-handle-buttons {
  width: 110px;
  margin: 0 5px;
}
.material-symbols-outlined {
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 24;
}
.button-row {
  margin-top: 10px;
}
.dialpad-container {
  text-align: center;
}

.dialpad-letters {
  font-size: 10px;
  margin-top: 10px;
  color: #ccc5c5;
}

.dialpad-filler {
  visibility: hidden;
}

/* .btn {
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 0.5;
  border-radius: 0.25rem;
} */

.dialpad-number {
  font-size: 15px;
  font-weight: bold;
}
.dialpad-button {
  width: 23%;
  height: 55px;
  margin-right: 5px;
  margin-left: 5px;
}

.dialer-call-button {
  color: rgb(255, 255, 255);
  background: #0f9d58;
  font-size: 35px;
  padding: 10px;
  border-radius: 50%;
}
.dialer-container {
  background-color: #12344d;
  /* background-color: #08255c; */
  display: flex;
  align-items: center;
  height: 56px;
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%), 0 0 4px 0 rgb(0 0 0 / 10%);
  font-size: 14px;
  color: #fff;
  margin: -10px -10px 5px -10px;
}


.call-handler-dialpad-container {
  margin-top: 10px;
  height: 350px;
  width: 100%;
  /* border-color: #2c5cc5;
  border-style: double; */
}
</style>
